/* Lake Life Designs Theme JS */
'use strict';

// ── Sticky header ──────────────────────────────────────────────────────
var header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', function() {
    header.classList.toggle('scrolled', window.scrollY > 8);
  }, { passive: true });
}

// ── Mobile menu ────────────────────────────────────────────────────────
var menuToggle = document.querySelector('.mobile-menu-toggle');
var mobileNav  = document.querySelector('.mobile-nav');
if (menuToggle && mobileNav) {
  menuToggle.addEventListener('click', function() {
    var open = mobileNav.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', String(open));
    var spans = menuToggle.querySelectorAll('span');
    if (open) {
      spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
      spans[1].style.opacity   = '0';
      spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
    } else {
      [].forEach.call(spans, function(s) { s.style.transform = ''; s.style.opacity = ''; });
    }
  });
}

// ── Hero Slideshow ─────────────────────────────────────────────────────
(function() {
  var slides  = document.querySelectorAll('.hero-slide');
  var dots    = document.querySelectorAll('.slideshow-dot');
  var prevBtn = document.querySelector('.slideshow-arrow--prev');
  var nextBtn = document.querySelector('.slideshow-arrow--next');
  if (!slides.length) return;

  var current  = 0;
  var timer    = null;
  var interval = 5000;

  function goTo(n) {
    slides[current].classList.remove('active');
    dots[current]  && dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current]  && dots[current].classList.add('active');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, interval);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); startTimer(); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); startTimer(); });
  });

  if (slides.length > 1) startTimer();
})();

// ── Scroll reveal ──────────────────────────────────────────────────────
if ('IntersectionObserver' in window) {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
}

// ── Product gallery ────────────────────────────────────────────────────
var thumbs  = document.querySelectorAll('.product-gallery__thumb');
var mainImg = document.querySelector('.product-gallery__main img');
thumbs.forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    if (mainImg) {
      var src = thumb.querySelector('img').getAttribute('src').replace(/_(150|200|300|400)x/, '_800x');
      mainImg.src = src; mainImg.srcset = '';
    }
  });
});

// ── Quantity selectors ─────────────────────────────────────────────────
document.querySelectorAll('.quantity-selector').forEach(function(sel) {
  var inp = sel.querySelector('input');
  if (!inp) return;
  var minus = sel.querySelector('.qty-minus');
  var plus  = sel.querySelector('.qty-plus');
  if (minus) minus.addEventListener('click', function() { inp.value = Math.max(1, parseInt(inp.value || 1) - 1); });
  if (plus)  plus.addEventListener('click',  function() { inp.value = parseInt(inp.value || 1) + 1; });
});

// ── Variant buttons ────────────────────────────────────────────────────
document.querySelectorAll('.variant-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var group = btn.closest('.variant-options');
    if (group) group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });
});

// ── AJAX Add to Cart ───────────────────────────────────────────────────
var atcForm = document.querySelector('[data-add-to-cart-form]');
if (atcForm) {
  atcForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn  = atcForm.querySelector('[data-add-to-cart]');
    var orig = btn.innerHTML;
    btn.innerHTML = 'Adding&hellip;';
    btn.disabled  = true;
    var id  = atcForm.querySelector('[name="id"]').value;
    var qty = parseInt((atcForm.querySelector('[name="quantity"]') || {}).value) || 1;
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: id, quantity: qty })
    }).then(function(r) {
      if (!r.ok) throw new Error();
      btn.innerHTML = 'Added!';
      refreshCartCount();
    }).catch(function() {
      btn.innerHTML = 'Error — try again';
    }).finally(function() {
      setTimeout(function() { btn.innerHTML = orig; btn.disabled = false; }, 2500);
    });
  });
}

function refreshCartCount() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(c) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent   = c.item_count;
        el.style.display = c.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function() {});
}
refreshCartCount();

// ── Homepage search ────────────────────────────────────────────────────
var homeSearch = document.querySelector('[data-home-search]');
if (homeSearch) {
  homeSearch.addEventListener('submit', function(e) {
    e.preventDefault();
    var q = homeSearch.querySelector('input').value.trim();
    if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  });
}

// ── Filter drawer toggle ───────────────────────────────────────────────
var filterToggle = document.getElementById('FilterToggle');
var filterDrawer = document.getElementById('FilterDrawer');
if (filterToggle && filterDrawer) {
  filterToggle.addEventListener('click', function() {
    var isHidden = filterDrawer.hasAttribute('hidden');
    if (isHidden) {
      filterDrawer.removeAttribute('hidden');
      filterToggle.setAttribute('aria-expanded', 'true');
    } else {
      filterDrawer.setAttribute('hidden', '');
      filterToggle.setAttribute('aria-expanded', 'false');
    }
  });
}

// Preserve scroll position after filter form submit
var filterForm = document.getElementById('FilterForm');
if (filterForm) {
  filterForm.addEventListener('submit', function() {
    var url = new URL(window.location.href);
    var formData = new FormData(filterForm);
    formData.forEach(function(value, key) {
      if (key !== 'sort_by') url.searchParams.set(key, value);
    });
    window.location.href = filterForm.action + '?' + new URLSearchParams(formData).toString();
  });
}

// ── Collection: view-as column switcher ───────────────────────────────
var viewBtns = document.querySelectorAll('.view-as__btn');
var productGrid = document.getElementById('ProductGrid');
viewBtns.forEach(function(btn) {
  btn.addEventListener('click', function() {
    var cols = btn.getAttribute('data-cols');
    viewBtns.forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    if (productGrid) productGrid.setAttribute('data-cols', cols);
  });
});

// ── Collection: mobile sidebar open/close ─────────────────────────────
var sidebar     = document.getElementById('CollectionSidebar');
var sidebarClose = document.getElementById('SidebarClose');
// Reuse the existing filter toggle button if present, else look for mobile trigger
var mobileTrigger = document.querySelector('.mobile-filter-trigger');
if (sidebarClose && sidebar) {
  sidebarClose.addEventListener('click', function() { sidebar.classList.remove('open'); });
}
// Add a mobile filter button to toolbar if on mobile
(function() {
  var toolbar = document.querySelector('.collection-toolbar__left');
  if (!toolbar || !sidebar) return;
  var btn = document.createElement('button');
  btn.className = 'btn btn--outline mobile-filter-trigger';
  btn.style.cssText = 'display:none;align-items:center;gap:6px;font-size:0.8rem;padding:0.45em 0.9em;';
  btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg> Filters';
  btn.addEventListener('click', function() { sidebar.classList.add('open'); });
  toolbar.prepend(btn);
  if (window.innerWidth <= 860) btn.style.display = 'inline-flex';
  window.addEventListener('resize', function() {
    btn.style.display = window.innerWidth <= 860 ? 'inline-flex' : 'none';
  });
})();

// ── Price range filter apply ────────────────────────────────────────────
function applyPriceFilter(btn) {
  var wrap  = btn.closest('.sidebar-price-range');
  var minEl = wrap.querySelector('[id$="_min"]');
  var maxEl = wrap.querySelector('[id$="_max"]');
  var url   = new URL(window.location.href);
  if (minEl && minEl.value !== '') url.searchParams.set(minEl.name, minEl.value);
  else if (minEl) url.searchParams.delete(minEl.name);
  if (maxEl && maxEl.value !== '') url.searchParams.set(maxEl.name, maxEl.value);
  else if (maxEl) url.searchParams.delete(maxEl.name);
  window.location.href = url.toString();
}

// ── Search page mobile sidebar ──────────────────────────────────────────
(function() {
  var searchSidebar = document.getElementById('SearchSidebar');
  var searchClose   = document.getElementById('SearchSidebarClose');
  if (!searchSidebar) return;
  if (searchClose) searchClose.addEventListener('click', function() { searchSidebar.classList.remove('open'); });

  // Inject a mobile filter button into the search toolbar
  var toolbar = document.querySelector('.search-page-body .collection-toolbar__left');
  if (toolbar) {
    var btn = document.createElement('button');
    btn.className = 'btn btn--outline';
    btn.style.cssText = 'display:none;align-items:center;gap:6px;font-size:0.8rem;padding:0.45em 0.9em;';
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg> Filters';
    btn.addEventListener('click', function() { searchSidebar.classList.add('open'); });
    toolbar.prepend(btn);
    function toggleBtn() { btn.style.display = window.innerWidth <= 860 ? 'inline-flex' : 'none'; }
    toggleBtn();
    window.addEventListener('resize', toggleBtn);
  }
})();

/* ── Sliding sticky header ───────────────────────────────────────────── */
/* The top bar scrolls away naturally. The header starts below it and
   slides up to lock at top:0 as the top bar disappears off screen. */
(function() {
  var wrap     = null;
  var topBar   = null;
  var annBar   = null;
  var ticking  = false;

  function getTopOffset() {
    /* Combined height of announcement bar + top bar still visible above fold */
    var offset = 0;
    if (annBar)  offset += annBar.offsetHeight;
    if (topBar)  offset += topBar.offsetHeight;
    return offset;
  }

  function update() {
    if (!wrap) return;
    var scrollY    = window.pageYOffset || document.documentElement.scrollTop;
    var topOffset  = getTopOffset();
    /* How far the bars have scrolled away — clamp between 0 and full bar height */
    var scrolledAway = Math.min(scrollY, topOffset);
    /* Header top = bar height minus how much has scrolled away (slides to 0) */
    var headerTop  = topOffset - scrolledAway;
    wrap.style.top = headerTop + 'px';

    /* Body padding = bars still showing + header height */
    var headerH = wrap.offsetHeight;
    document.body.style.paddingTop = (topOffset - scrolledAway + headerH) + 'px';

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function init() {
    wrap   = document.querySelector('.site-header-wrap');
    topBar = document.querySelector('.top-bar');
    annBar = document.querySelector('.announcement-bar');
    if (!wrap) return;
    /* Remove the CSS top:0 so JS controls it */
    wrap.style.transition = 'none';
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() { update(); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Header scroll shadow ─────────────────────────────────────────────── */
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 10) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });
})();

/* ══════════════════════════════════════════════════════════════════════
   Smart Breadcrumb — tracks where the user came from
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORAGE_KEY = 'lld_breadcrumb';

  /* ── Search page: save search term ──────────────────────────────────── */
  if (window.location.pathname === '/search') {
    var term = new URLSearchParams(window.location.search).get('q') || '';
    if (term) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          label: term,
          url:   window.location.href
        }));
      } catch(e) {}
    }
  }

  /* ── Collection page: save collection title + URL ───────────────────── */
  if (window.location.pathname.indexOf('/collections/') === 0
      && window.location.pathname.indexOf('/products/') === -1) {
    var h1 = document.querySelector('.collection-hero__title, h1');
    var title = h1 ? h1.textContent.trim() : '';
    if (title) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          label: title,
          url:   window.location.href
        }));
      } catch(e) {}
    }
  }

  /* ── Product page: show the middle breadcrumb crumb ─────────────────── */
  var breadcrumb = document.getElementById('ProductBreadcrumb');
  if (!breadcrumb) return;

  var middleItem = document.getElementById('BreadcrumbMiddle');
  var middleLink = document.getElementById('BreadcrumbMiddleLink');
  if (!middleItem || !middleLink) return;

  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch(e) {}

  if (saved && saved.label && saved.url) {
    middleLink.textContent = saved.label;
    middleLink.href        = saved.url;
    middleItem.style.display = '';
  } else {
    /* Fallback: use first collection */
    var fallbackUrl   = breadcrumb.getAttribute('data-collection-url');
    var fallbackTitle = breadcrumb.getAttribute('data-collection-title');
    if (fallbackUrl && fallbackTitle) {
      middleLink.textContent = fallbackTitle;
      middleLink.href        = fallbackUrl;
      middleItem.style.display = '';
    }
  }

})();

/* ── Dynamic body padding — always matches fixed header height ────────── */
(function () {
  function updatePadding() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    /* Force a reflow so offsetHeight reflects the current vh-based height */
    var h = header.getBoundingClientRect().height;
    document.body.style.setProperty('padding-top', h + 'px', 'important');
  }
  /* Run immediately, after DOM ready, and after fonts/images load */
  updatePadding();
  document.addEventListener('DOMContentLoaded', updatePadding);
  window.addEventListener('load', updatePadding);
  window.addEventListener('resize', updatePadding);
  /* Also run on next frame to catch any delayed layout */
  requestAnimationFrame(function () {
    requestAnimationFrame(updatePadding);
  });
})();
